import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { LottieControl } from 'Components/ComponentLibrary/Organisms/LottieControl';
import { useLottieLoadingContext } from 'Components/ComponentLibrary/Organisms/LottieControl/LottieLoadingLayout';


export const TaxDiagnosticLottie = ({ src }) => {
  const { setIsContentShowing } = useLottieLoadingContext();

  useEffect(() => {
    setIsContentShowing(false);
  }, []);

  return (
    <LottieControl
      src={src}
      onLoadSuccess={() => setIsContentShowing(true)}
      onLoadError={() => setIsContentShowing(true)}
      height={'auto'}
      width={'100%'}
    />
  );
};

TaxDiagnosticLottie.propTypes = {
  src: PropTypes.string.isRequired,
};
